import {
    BaseSearcherState,
    initialBaseSearcherState
} from '@/components/common/searcher/components/base/base-searcher.model'
import { IdentifierTypeResponse } from '@/api/resources/common/initialization/common-initialization.dto'
import { CommonCenterResponse } from '@/api/services/common/center/common-center.dto'
import { StrictNullable } from '@/shared/types/app.types'

export interface PatientSearcherRequestParams {
    id: string
    name: string
    middleName: string
    surname1: string
    surname2: string
    identifierType: StrictNullable<IdentifierTypeResponse>
    center: StrictNullable<CommonCenterResponse>
}

export interface PatientSearcherState extends BaseSearcherState {
    identifierTypes: IdentifierTypeResponse[]
    identifierType: StrictNullable<IdentifierTypeResponse>

    centers: CommonCenterResponse[]
    center: StrictNullable<CommonCenterResponse>

    id: string
    name: string
    middleName: string
    surname1: string
    surname2: string
}
export const initialPatientSearcherState =
    (): PatientSearcherState => ({
        ...initialBaseSearcherState(),

        identifierTypes: [],
        identifierType: null,

        centers: [],
        center: null,

        id: '',
        name: '',
        middleName: '',
        surname1: '',
        surname2: ''
    })
